import { Button } from "@volca/ui/components/ui/button";
import { toast } from "@volca/ui/lib/toast";
import { openSupportChatWithMessage } from "@/core/pylon";
import type { WorkbookAccessNextStep as NextStep } from "./use-workbook-access-setup";
import { WorkbookAccessLink } from "./workbook-access-link";

const SETUP_REQUEST =
  "Hi! Workbook access isn't set up for our business yet, so we can't see our payroll. Can you set it up?";

interface WorkbookAccessNextStepProps {
  nextStep: NextStep;
  isUnconfigured: boolean;
}

export const WorkbookAccessNextStep = ({
  nextStep,
  isUnconfigured,
}: WorkbookAccessNextStepProps) => {
  if (nextStep === "settings")
    return (
      <WorkbookAccessLink>
        {isUnconfigured ? "Set up workbook access" : "Open workbook access"}
      </WorkbookAccessLink>
    );

  return (
    <Button
      variant="outline"
      onClick={() => {
        if (!openSupportChatWithMessage(SETUP_REQUEST))
          toast.error(
            "Chat could not open. Please refresh the page and try again.",
          );
      }}
    >
      Contact support
    </Button>
  );
};
